import {DateIntervalType} from "./interval"
import DatetimeUtils from "../datetime-utils"
import GroupBy from "../../manager/group-by/group-by-model"

// const debug = "getIntervalValue"
const debug = false

export function getIntervalValue(value: string | Moment, groupBy?: GroupBy): string {
    const interval = groupBy?.params.interval || DateIntervalType.DAILY

    let groupValue  : string = ''

    // normalize value to Moment
    let momentValue       : Moment
    if (moment.isMoment(value)) {
        // Clone the moment object to avoid mutating the original value when applying modifications such as startOf
        momentValue = moment(value)
    } else {
        momentValue = DatetimeUtils.datetimeToMoment(value)
    }

    if (!momentValue) {
        return ''
    }

    switch (interval) {
        case DateIntervalType.YEARLY:
            groupValue           = momentValue.startOf('year').format('YYYY-MM-DD')
            break

        case DateIntervalType.QUARTERLY:
            groupValue           = momentValue.startOf('quarter').format('YYYY-MM-DD')
            break

        case DateIntervalType.MONTHLY:
            groupValue           = momentValue.startOf('month').format('YYYY-MM-DD')
            break

        case DateIntervalType.BIWEEKLY:
            // calculate start of bi week period
            const referenceDate = momentValue.clone().startOf("isoWeek")
            const isSecondOfTwoWeeks = (momentValue.isoWeek() % 2) === 0
            // if momentValue is second of be week then subtract one week so that referenceDate is first of two weeks
            if (isSecondOfTwoWeeks) {
                referenceDate.subtract(1, "week")
            }

            groupValue = referenceDate.startOf("isoWeek").format('YYYY-MM-DD')
            break

        case DateIntervalType.WEEKLY:
            groupValue           = momentValue.clone().startOf("isoWeek").format('YYYY-MM-DD')
            break

        case DateIntervalType.DAILY:
        default:
            groupValue           = momentValue.clone().startOf("day").format('YYYY-MM-DD')
            break
    }

    return groupValue
}